import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormControl } from 'react-bootstrap';
import { trackPageView } from '../util/Analytics.jsx';

export default class AboutPage extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleServerSubChange = this.handleServerSubChange.bind(this);
		trackPageView();

		const serverSub = localStorage.getItem('serverSub') || 'www';
		this.state = {
			clickCount: serverSub === 'www' ? 0 : 10,
			serverSub,
			appVersion: window.appVersion || null
		};
	}

	handleClick() {
		const clickCount = this.state.clickCount;
		this.setState({
			clickCount: clickCount + 1
		});
	}

	handleServerSubChange(e) {
		if (e.target.value === 'www') {
			localStorage.removeItem('serverSub');
		} else {
			localStorage.setItem('serverSub', e.target.value);
		}
		this.setState({
			serverSub: e.target.value
		});
	}

	render() {
		const serverSubDropdown = this.state.clickCount < 10
			? null
			: (
				<FormControl
					componentClass="select"
					value={this.state.serverSub}
					onChange={this.handleServerSubChange}>
					<option value="www">Production</option>
					<option value="test">Test</option>
					<option value="chester">Chester</option>
					<option value="chris">Chris</option>
				</FormControl>
			);
		return (
			<div className="pageContent">
				<h2>About</h2>
				<div>
					<div>SiteWalker by <span onClick={this.handleClick}>Hito</span> Management</div>
					{this.state.appVersion === null ? null : (<div>App version {this.state.appVersion}</div>)}
					<Link to='/'>
						<Button>
							<span className="glyphicon glyphicon-arrow-left leftGlyph"></span>
							Home
						</Button>
					</Link>
					{serverSubDropdown}
				</div>
			</div>
		);
	}
}
